const elementDefinitions = [
    { symbol: "H",  number: 1, group: 1, period: 1, name: "Hidrogênio" },
    { symbol: "He", number: 2, group: 18, period: 1, name: "Hélio" },
    { symbol: "Li", number: 3, group: 1, period: 2, name: "Lítio" },
    { symbol: "Be", number: 4, group: 2, period: 2, name: "Berílio" },
    { symbol: "B",  number: 5, group: 13, period: 2, name: "Boro" },
    { symbol: "C",  number: 6, group: 14, period: 2, name: "Carbono" },
    { symbol: "N",  number: 7, group: 15, period: 2, name: "Nitrogênio" },
    { symbol: "O",  number: 8, group: 16, period: 2, name: "Oxigênio" },
    { symbol: "F",  number: 9, group: 17, period: 2, name: "Flúor" },
    { symbol: "Ne", number: 10, group: 18, period: 2, name: "Neônio" },
    { symbol: "Na", number: 11, group: 1, period: 3, name: "Sódio" },
    { symbol: "Mg", number: 12, group: 2, period: 3, name: "Magnésio" },
    { symbol: "Al", number: 13, group: 13, period: 3, name: "Alumínio" },
    { symbol: "Si", number: 14, group: 14, period: 3, name: "Silício" },
    { symbol: "P", number: 15, group: 15, period: 3, name: "Fósforo" },
    { symbol: "S", number: 16, group: 16, period: 3, name: "Enxofre" },
    { symbol: "Cl", number: 17, group: 17, period: 3, name: "Cloro" },
    { symbol: "Ar", number: 18, group: 18, period: 3, name: "Argônio" },
    { symbol: "K", number: 19, group: 1, period: 4, name: "Potássio" },
    { symbol: "Ca", number: 20, group: 2, period: 4, name: "Cálcio" },
    { symbol: "Sc", number: 21, group: 3, period: 4, name: "Escândio" },
    { symbol: "Ti", number: 22, group: 4, period: 4, name: "Titânio" },
    { symbol: "V", number: 23, group: 5, period: 4, name: "Vanádio" },
    { symbol: "Cr", number: 24, group: 6, period: 4, name: "Cromo" },
    { symbol: "Mn", number: 25, group: 7, period: 4, name: "Manganês" },
    { symbol: "Fe", number: 26, group: 8, period: 4, name: "Ferro" },
    { symbol: "Co", number: 27, group: 9, period: 4, name: "Cobalto" },
    { symbol: "Ni", number: 28, group: 10, period: 4, name: "Níquel" },
    { symbol: "Cu", number: 29, group: 11, period: 4, name: "Cobre" },
    { symbol: "Zn", number: 30, group: 12, period: 4, name: "Zinco" },
    { symbol: "Ga", number: 31, group: 13, period: 4, name: "Gálio" },
    { symbol: "Ge", number: 32, group: 14, period: 4, name: "Germânio" },
    { symbol: "As", number: 33, group: 15, period: 4, name: "Arsênio" },
    { symbol: "Se", number: 34, group: 16, period: 4, name: "Selênio" },
    { symbol: "Br", number: 35, group: 17, period: 4, name: "Bromo" },
    { symbol: "Kr", number: 36, group: 18, period: 4, name: "Criptônio" },
    { symbol: "Rb", number: 37, group: 1, period: 5, name: "Rubídio" },
    { symbol: "Sr", number: 38, group: 2, period: 5, name: "Estrôncio" },
    { symbol: "Y", number: 39, group: 3, period: 5, name: "Ítrio" },
    { symbol: "Zr", number: 40, group: 4, period: 5, name: "Zircônio" },
    { symbol: "Nb", number: 41, group: 5, period: 5, name: "Nióbio" },
    { symbol: "Mo", number: 42, group: 6, period: 5, name: "Molibdênio" },
    { symbol: "Tc", number: 43, group: 7, period: 5, name: "Tecnécio" },
    { symbol: "Ru", number: 44, group: 8, period: 5, name: "Rutênio" },
    { symbol: "Rh", number: 45, group: 9, period: 5, name: "Ródio" },
    { symbol: "Pd", number: 46, group: 10, period: 5, name: "Paládio" },
    { symbol: "Ag", number: 47, group: 11, period: 5, name: "Prata" },
    { symbol: "Cd", number: 48, group: 12, period: 5, name: "Cádmio" },
    { symbol: "In", number: 49, group: 13, period: 5, name: "Índio" },
    { symbol: "Sn", number: 50, group: 14, period: 5, name: "Estanho" },
    { symbol: "Sb", number: 51, group: 15, period: 5, name: "Antimônio" },
    { symbol: "Te", number: 52, group: 16, period: 5, name: "Telúrio" },
    { symbol: "I", number: 53, group: 17, period: 5, name: "Iodo" },
    { symbol: "Xe", number: 54, group: 18, period: 5, name: "Xenônio" },
    { symbol: "Cs", number: 55, group: 1, period: 6, name: "Césio" },
    { symbol: "Ba", number: 56, group: 2, period: 6, name: "Bário" },
    { symbol: "La", number: 57, group: 3, period: 6, name: "Lantânio" },
    { symbol: "Ce", number: 58, group: 4, period: 8, name: "Cério" },
    { symbol: "Pr", number: 59, group: 5, period: 8, name: "Praseodímio" },
    { symbol: "Nd", number: 60, group: 6, period: 8, name: "Neodímio" },
    { symbol: "Pm", number: 61, group: 7, period: 8, name: "Promécio" },
    { symbol: "Sm", number: 62, group: 8, period: 8, name: "Samário" },
    { symbol: "Eu", number: 63, group: 9, period: 8, name: "Európio" },
    { symbol: "Gd", number: 64, group: 10, period: 8, name: "Gadolínio" },
    { symbol: "Tb", number: 65, group: 11, period: 8, name: "Térbio" },
    { symbol: "Dy", number: 66, group: 12, period: 8, name: "Disprósio" },
    { symbol: "Ho", number: 67, group: 13, period: 8, name: "Hólmio" },
    { symbol: "Er", number: 68, group: 14, period: 8, name: "Érbio" },
    { symbol: "Tm", number: 69, group: 15, period: 8, name: "Túlio" },
    { symbol: "Yb", number: 70, group: 16, period: 8, name: "Itérbio" },
    { symbol: "Lu", number: 71, group: 17, period: 8, name: "Lutécio" },
    { symbol: "Hf", number: 72, group: 4, period: 6, name: "Háfnio" },
    { symbol: "Ta", number: 73, group: 5, period: 6, name: "Tântalo" },
    { symbol: "W", number: 74, group: 6, period: 6, name: "Tungstênio" },
    { symbol: "Re", number: 75, group: 7, period: 6, name: "Rênio" },
    { symbol: "Os", number: 76, group: 8, period: 6, name: "Ósmio" },
    { symbol: "Ir", number: 77, group: 9, period: 6, name: "Irídio" },
    { symbol: "Pt", number: 78, group: 10, period: 6, name: "Platina" },
    { symbol: "Au", number: 79, group: 11, period: 6, name: "Ouro" },
    { symbol: "Hg", number: 80, group: 12, period: 6, name: "Mercúrio" },
    { symbol: "Tl", number: 81, group: 13, period: 6, name: "Tálio" },
    { symbol: "Pb", number: 82, group: 14, period: 6, name: "Chumbo" },
    { symbol: "Bi", number: 83, group: 15, period: 6, name: "Bismuto" },
    { symbol: "Po", number: 84, group: 16, period: 6, name: "Polônio" },
    { symbol: "At", number: 85, group: 17, period: 6, name: "Astato" },
    { symbol: "Rn", number: 86, group: 18, period: 6, name: "Radônio" },
    { symbol: "Fr", number: 87, group: 1, period: 7, name: "Frâncio" },
    { symbol: "Ra", number: 88, group: 2, period: 7, name: "Rádio" },
    { symbol: "Ac", number: 89, group: 3, period: 7, name: "Actínio" },
    { symbol: "Th", number: 90, group: 4, period: 9, name: "Tório" },
    { symbol: "Pa", number: 91, group: 5, period: 9, name: "Protactínio" },
    { symbol: "U", number: 92, group: 6, period: 9, name: "Urânio" },
    { symbol: "Np", number: 93, group: 7, period: 9, name: "Neptúnio" },
    { symbol: "Pu", number: 94, group: 8, period: 9, name: "Plutônio" },
    { symbol: "Am", number: 95, group: 9, period: 9, name: "Amerício" },
    { symbol: "Cm", number: 96, group: 10, period: 9, name: "Cúrio" },
    { symbol: "Bk", number: 97, group: 11, period: 9, name: "Berquélio" },
    { symbol: "Cf", number: 98, group: 12, period: 9, name: "Califórnio" },
    { symbol: "Es", number: 99, group: 13, period: 9, name: "Einstênio" },
    { symbol: "Fm", number: 100, group: 14, period: 9, name: "Férmio" },
    { symbol: "Md", number: 101, group: 15, period: 9, name: "Mendelévio" },
    { symbol: "No", number: 102, group: 16, period: 9, name: "Nobélio" },
    { symbol: "Lr", number: 103, group: 17, period: 9, name: "Laurêncio" },
    { symbol: "Rf", number: 104, group: 4, period: 7, name: "Rutherfórdio" },
    { symbol: "Db", number: 105, group: 5, period: 7, name: "Dúbnio" },
    { symbol: "Sg", number: 106, group: 6, period: 7, name: "Seabórgio" },
    { symbol: "Bh", number: 107, group: 7, period: 7, name: "Bóhrio" },
    { symbol: "Hs", number: 108, group: 8, period: 7, name: "Hássio" },
    { symbol: "Mt", number: 109, group: 9, period: 7, name: "Meitnério" },
    { symbol: "Ds", number: 110, group: 10, period: 7, name: "Darmstádtio" },
    { symbol: "Rg", number: 111, group: 11, period: 7, name: "Roentgênio" },
    { symbol: "Cn", number: 112, group: 12, period: 7, name: "Copernício" },
    { symbol: "Nh", number: 113, group: 13, period: 7, name: "Nihônio" },
    { symbol: "Fl", number: 114, group: 14, period: 7, name: "Fleróvio" },
    { symbol: "Mc", number: 115, group: 15, period: 7, name: "Moscóvio" },
    { symbol: "Lv", number: 116, group: 16, period: 7, name: "Livermório" },
    { symbol: "Ts", number: 117, group: 17, period: 7, name: "Tenesso" },
    { symbol: "Og", number: 118, group: 18, period: 7, name: "Oganessônio" }
];

const categorySymbols = {
  "alkali-metal": ["Li", "Na", "K", "Rb", "Cs", "Fr"],
  "alkaline-earth-metal": ["Be", "Mg", "Ca", "Sr", "Ba", "Ra"],
  lanthanide: ["La", "Ce", "Pr", "Nd", "Pm", "Sm", "Eu", "Gd", "Tb", "Dy", "Ho", "Er", "Tm", "Yb", "Lu"],
  actinide: ["Ac", "Th", "Pa", "U", "Np", "Pu", "Am", "Cm", "Bk", "Cf", "Es", "Fm", "Md", "No", "Lr"],
  "transition-metal": ["Sc", "Ti", "V", "Cr", "Mn", "Fe", "Co", "Ni", "Cu", "Zn", "Y", "Zr", "Nb", "Mo", "Tc", "Ru", "Rh", "Pd", "Ag", "Cd", "Hf", "Ta", "W", "Re", "Os", "Ir", "Pt", "Au", "Hg", "Rf", "Db", "Sg", "Bh", "Hs", "Mt", "Ds", "Rg", "Cn"],
  "post-transition-metal": ["Al", "Ga", "In", "Sn", "Tl", "Pb", "Bi", "Nh", "Fl", "Mc", "Lv"],
  metalloid: ["B", "Si", "Ge", "As", "Sb", "Te", "Po"],
  "reactive-nonmetal": ["H", "C", "N", "O", "P", "S", "Se"],
  halogen: ["F", "Cl", "Br", "I", "At", "Ts"],
  "noble-gas": ["He", "Ne", "Ar", "Kr", "Xe", "Rn", "Og"],
};

export const CATEGORY_LABELS = {
  "alkali-metal": "Metal alcalino",
  "alkaline-earth-metal": "Metal alcalino-terroso",
  "transition-metal": "Metal de transição",
  "post-transition-metal": "Metal pós-transição",
  metalloid: "Metaloide",
  "reactive-nonmetal": "Não metal reativo",
  halogen: "Halogênio",
  "noble-gas": "Gás nobre",
  lanthanide: "Lantanídeo",
  actinide: "Actinídeo",
};

const categoryBySymbol = Object.entries(categorySymbols).reduce(
  (categories, [category, symbols]) => {
    symbols.forEach((symbol) => {
      categories[symbol] = category;
    });
    return categories;
  },
  {},
);

export const elementos = elementDefinitions.map((element) => ({
  ...element,
  category: categoryBySymbol[element.symbol],
}));
